module.exports = __webpack_public_path__ + "media/images/new_marketing/brain_floating-a6b28066cbde5ce154cd7f9c9514306233477fbe4bf29adf29e8abb1bd927098.png";